import styled from "styled-components";

export const MainContainer = styled.div`
  padding: 5% 2%;
`;